module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "base-five border-top padding-top full-width margin-right"
  }, [(_vm.screenSize.mobile || _vm.location.single || _vm.location["verdieping-programma"] || _vm.location["verdieping-mapping"] || _vm.location["verdieping-links-naar-meer"]) ? _c('dsMenu', {
    attrs: {
      "language": _vm.language
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-166c8cf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsFooter.vue
// module id = 211
// module chunks = 2